import React, { PureComponent } from 'react';
import WND from '../WND.js';
import ICONS from '../ICONS';
import MENUBAR from '../menus/MENUBAR';
import STATUSBAR from '../STATUSBAR';
import './EXPLORER.css';
import EXPLCTRL from './EXPLCTRL.js';

export default class EXPLORE extends WND {
    constructor(props) {
        super(props);

        let initialPath = props.commandLine || ""; // Default to "My Computer"

        this.state.currentPath = initialPath;
        this.state.currentInfo = window.WINAPI.GetFileInfo(this.state.currentPath);
        this.state.currentDirectory = window.WINAPI.FindFile(this.state.currentPath);
    }

    applicationContent() {
        return <EXPLCTRL path={this.state.currentPath}
            directory={this.state.currentDirectory}
            showChrome={true}
            ref={(c) => {this.explctrl = c}} />;
    }

    icon() {
        return this.state.currentInfo.icon16;
    }

    title() {
        return this.state.currentInfo.displayName || this.state.currentInfo.name;
    }

    defaultSize() {
        return {h: 219, w: 265};
    }

    onFocusLost() {
        if (this.explctrl) {
            this.explctrl.onFocusLost();
        }
    }
}


// WEBPACK FOOTER //
// ./src/walleris/EXPLORE/EXPLORER.js